var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
      _vm.$route.matched[1].name == 'ParsinaSupport' &&
      _vm.$route.name != 'parsinaSupportLogin'
    )?_c('the-parsina-header'):_vm._e(),(_vm.$route.matched[1].name != 'ParsinaSupport')?_c('the-header'):_vm._e(),_c('the-alerts'),_c('v-main',{class:{
      'dashboard-page':
        (_vm.$route.name === 'PACNTDashboard' && _vm.hasDashboardData) ||
        _vm.$route.name === 'PBANKDashboard' ||
        _vm.$route.name === 'PHAMYARDashboard' ||
        _vm.$route.name === 'PCRMDashboard' ||
        _vm.$route.name === 'PHAMSAZDashboard' ||
        _vm.$route.name === 'Dashboard',
    }},[_c('keep-alive',{attrs:{"max":20}},[(_vm.cachedTabKey)?_c('router-view',{key:_vm.cachedTabKey}):_vm._e()],1),(!_vm.cachedTabKey)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1):_vm._e(),_c('the-loading')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }